export const governmentClientInvoiceItemDefaults = {
  type: "GOVERNMENT",
  quantity: 1,
  hsnCode: "9954",
  taxRate: 18,
};
